export { NAV_ITEM_SERVICE } from '../services/navitem.service.interface';
export type { NavItemService } from '../services/navitem.service.interface';
